import {type PepIconName} from '@calvium/pep-icons';
import {Popover, PopoverButton, PopoverPanel} from '@headlessui/react';
import {PepIcon} from './PepIcon';
import {SmallText} from './Text';

type Props = {
  /**
   * The message to display in the tooltip.
   * Example use : "This is a **bolded** message."
   */
  tooltipWithEmphasis: string;
  /**
   * The icon to display in the tooltip.
   * @default 'Information'
   */
  iconName?: PepIconName;
};
/**
 * A tooltip that displays a message with bolded text for emphasis. The bolded text is indicated by wrapping it in double asterisks.
 */
export const PopoverTooltip = (props: Props) => {
  const {tooltipWithEmphasis, iconName = 'Information'} = props;

  const tooltipParts = tooltipWithEmphasis.split('**');

  return (
    <Popover>
      <PopoverButton>
        <PepIcon iconName={iconName} strokeColor="primary" strokeColorHover="secondary" />
      </PopoverButton>

      <PopoverPanel
        anchor={{to: 'bottom start', gap: 8}}
        className="z-10 rounded-xl border-2 border-primary bg-background p-3 shadow-lg"
      >
        <SmallText>
          {tooltipParts.map((tooltipPart, index) => {
            if (index % 2 === 0) {
              return <span key={index}>{tooltipPart}</span>;
            } else {
              return (
                <span key={index} className="font-bold text-primary">
                  {tooltipPart}
                </span>
              );
            }
          })}
        </SmallText>
      </PopoverPanel>
    </Popover>
  );
};
